import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data/content";
import { FadeIn } from "./Reveal";

export const FullBleed = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      data-testid="fullbleed-section"
      className="relative h-[70vh] overflow-hidden"
    >
      <motion.img
        style={{ y }}
        src={IMAGES.fullbleed}
        alt="An architectural celebration venue dressed by SORA"
        loading="lazy"
        className="absolute -top-[12%] left-0 h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#2e2f1e]/30" />
      <div className="relative z-10 flex h-full items-center justify-center px-6">
        <FadeIn>
          <p className="text-center font-serif text-3xl font-light italic text-ivory sm:text-5xl">
            The art of celebration.
          </p>
        </FadeIn>
      </div>
    </section>
  );
};
